import { combineReducers } from 'redux';
import { merge, mergeWith } from 'lodash-es';
import {
  publicationStatusValues,
  surveyTypeValues
} from '../../constants/types';

import {
  UPDATE_SURVEY_SCHEMA_OPTIONS,
  CLEAR_SURVEY_SCHEMA_OPTIONS,
  UPDATE_SURVEY_SCHEMA_PARTS
} from '../../actions';
import { arrayOverwritingMergeCustomizer } from '../../util';

const defaultSchemaOptions = {
  id: null,
  code: '',
  type: surveyTypeValues.DEGREE_PROGRAM_SURVEY,
  status: publicationStatusValues.DRAFT,
  title: {},
  description: {},
  introduction: {},
  conclusion: {},
  feedbackIntroduction: {},
  surveySchemaParts: []
};

const surveySchemaOptions = (state = defaultSchemaOptions, action) => {
  switch (action.type) {
    case UPDATE_SURVEY_SCHEMA_OPTIONS: {
      const options = action.payload;
      return merge({}, state, options);
    }
    case UPDATE_SURVEY_SCHEMA_PARTS: {
      const surveySchemaParts = action.payload;
      return mergeWith({}, state, { surveySchemaParts }, arrayOverwritingMergeCustomizer);
    }
    case CLEAR_SURVEY_SCHEMA_OPTIONS:
      return defaultSchemaOptions;
    default:
      return state;
  }
};

const surveySchema = combineReducers({
  surveySchemaOptions
});

export default surveySchema;
